import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import Annotations from '../Annotations';

Meteor.publish('annotations.onePublic', function videosView(annotationId) {
  check(annotationId, String);
  return Annotations.find({ _id: annotationId });
});

Meteor.publish('annotations.public', () => Annotations.find({}));

Meteor.publish('annotations.videoPublic', function annotations(videoId) {
  check(videoId, String);
  return Annotations.find({ 'geoJSON.properties.video': videoId });
});

Meteor.publish('annotations', function annotations(videoId) {
  return Annotations.find({ owner: this.userId, 'geoJSON.properties.video': videoId });
});

Meteor.publish('annotations.tracking', function annotationIsTracking() {
  return Annotations.find({
    isTracking: { $exists: true, $eq: true }
  });
});

// Note: annotations.view is also used when editing an existing document.
Meteor.publish('annotations.view', function annotationsView(annotationId) {
  check(annotationId, String);
  return Annotations.find(
    { _id: annotationId, owner: this.userId },
    {
      fields: {
        owner: 0,
        createdAt: 0,
        updatedAt: 0,
        'geoJSON.properties._id': 0,
        'geoJSON.properties.owner': 0,
        'geoJSON.properties.createdAt': 0,
        'geoJSON.properties.updatedAt': 0
      }
    }
  );
});

Meteor.publish('annotations.video', videoId => {
  check(videoId, String);
  return Annotations.find(
    { 'geoJSON.properties.video': videoId },
    {
      fields: {
        owner: 0,
        createdAt: 0,
        updatedAt: 0,
        'geoJSON.properties._id': 0,
        'geoJSON.properties.owner': 0,
        'geoJSON.properties.createdAt': 0,
        'geoJSON.properties.updatedAt': 0
      }
    }
  );
});

Meteor.publish('manyAnnotations.public', function videosView(multipleVideoId) {
  check(multipleVideoId, [String]);
  const annotationList = Annotations.find({
    'geoJSON.properties.video': { $in: multipleVideoId }
  });
  return annotationList;
});
